import styled from 'styled-components';
import { Gray } from '../../constants/styles';
const overlayShadow = (isAutocompleteOpen) => {
    if (isAutocompleteOpen) {
        return `
    &::after {
      background-color: hsla(0, 0%, 96%, 0.9);
      bottom: 0;
      content: '';
      left: 0;
      position: fixed;
      right: 0;
      top: 0;
      z-index: -2;
    }
    `;
    }
    return '';
};
export const DesktopContainerWrapper = styled('div') `
  position: relative;
  border-bottom: 1px solid ${Gray.x200};
  height: 81px;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};

  & > div:first-child {
    height: 100%;
  }

  ${({ isAutocompleteOpen }) => overlayShadow(isAutocompleteOpen)}
`;
export const MobileContainer = styled.div `
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${Gray.x200};
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
`;
export const MobileInnerContainer = styled.div `
  align-items: center;
  background-color: #fff;
  display: flex;
  padding: 10px 15px;
  z-index: 1;
  height: 71px;
`;
export const MenuButton = styled.button `
  align-items: center;
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  font-family: proxima-nova, Corbel, Arial, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sizeSm2};
  color: ${({ theme }) => theme.colorsV2.font.textPrimary};
  padding: 0;
  position: relative;

  > span {
    padding-top: 7px;
  }

  &:after {
    content: '';
    position: absolute;
    right: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.supportSuccess01};
  }
`;
export const HeaderContainer = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 11;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
`;
export const MobileLogoWrapper = styled.div `
  width: 100%;
  display: flex;
  justify-content: center;
  margin-right: ${({ isSearchBarVisible }) => (isSearchBarVisible ? '-40px' : 0)};
  transition: margin-right 0.3s ease;
`;
export const StyledInnerMenuWrapper = styled.div `
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;
export const StyledAutocompleteWrapper = styled.div `
  margin: 0 20px 0 40px;
  width: 100%;
  position: relative;
  height: 100%;
`;
const getNavigationRollUpStyles = (isVisible) => {
    if (isVisible) {
        return `
    border-bottom: 1px solid ${Gray.x200};
    top: 81px;
    visibility: visible;
  `;
    }
    return `
    border-bottom: 1px solid transparent;
    top: 2px;
    visibility: hidden;
  `;
};
export const NavigationRollUp = styled.div `
  position: absolute;
  height: 60px;
  width: 100%;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  z-index: -1;
  transition: border-bottom 0.3s ease, top 0.3s ease, visibility 0.3s ease;

  ${({ isVisible }) => getNavigationRollUpStyles(isVisible)}
`;
export const AutocompleteMobileWrapper = styled.div `
  position: ${({ isAutocompleteOpen }) => (isAutocompleteOpen ? 'absolute' : 'initial')};
  max-width: 100vw;
  height: auto;
  margin-top: ${({ isSearchBarVisible }) => (isSearchBarVisible ? '0' : '-57px')};
  transition: margin-top 0.3s ease;
  z-index: ${({ isAutocompleteOpen }) => (isAutocompleteOpen ? '1' : '0')};
`;
//# sourceMappingURL=Header.styled.js.map